import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=51eb9e8d&scoped=true&"
import script from "./PhoneInput.vue?vue&type=script&lang=ts&"
export * from "./PhoneInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51eb9e8d",
  null
  
)

export default component.exports